import { setFiltersFromSearchResults } from '../setFilters';
import { setSessionStorageItem } from '../../sessionStorage/utils';
import {
  SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS,
  SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS,
} from '../../../utils/constants';

export const createSetSearchResults = (filteredResultsVar, searchResultsVar) => {
  return (newSearchResults, shouldSaveInSessionStorage = false, useReturnResultsKey = false) => {
    searchResultsVar(newSearchResults);
    if (shouldSaveInSessionStorage) {
      setSessionStorageItem(
        useReturnResultsKey
          ? SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS
          : SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS,
        newSearchResults,
      );
    }
    setFiltersFromSearchResults(newSearchResults.flightFilters);
    filteredResultsVar(newSearchResults.matchingFlights);
  };
};

export default { createSetSearchResults };
